import { ReferenceData } from './reference-data.model';

export class JobType extends ReferenceData {

  standardHours: number;
  standardHoursFrequencyId: { correlation: string };
  compensationFrequencyId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.standardHours = data.standardHours;
    this.standardHoursFrequencyId = data.standardHoursFrequencyId;
    this.compensationFrequencyId = data.compensationFrequencyId;
  }
}
